import useSearchPagination from "../../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import React from "react";
import { useState } from "react";
import { IoMdClose } from "react-icons/io";

import { CgSpinner } from "react-icons/cg";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../store/userSlice";
import Highlighter from "react-highlight-words";
import LoadingWithLable from "../../../../../../ReusableComponents/Loading/LoadingWithLable";
import nodeinstance from "../../../../../../nodeInstance";

export default function Authorization({
  PopUp,
  setPopUp,
  url,
  title,
  callBack,
  list,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState();

  const [check, setCheck] = React.useState(false);

  const [searchWords, setSearchWords] = useState([]);
  const { NoDataFound, PaginationIndex, currentList } = useSearchPagination(
    list ? list : []
  );
  var titles = [
    "S.NO.",
    "EMPLOYEE ID",
    "VISA PROVIDER",
    "SPONSOR ID",
    "CLIENT NAME",
    "IQAMA NUMBER",
    "TENURE",
    "COMMENTS",
  ];
  const [tenureState, setTenureState] = useState({});
  const [commentsState, setCommentsState] = useState({});
  const handleDropChange = (empId, value) => {
    setTenureState((prev) => ({
      ...prev,
      [empId]: value,
    }));
  };

  const handleCommentsChange = (empId, value) => {
    setCommentsState((prev) => ({
      ...prev,
      [empId]: value,
    }));
  };
  const token = localStorage.getItem("nodeToken");
  const update = async () => {
    const employees = list.map((employee) => ({
      employee_id: employee.emp_id,
      tenure: tenureState[employee.emp_id] || employee.tenure,
      comment: commentsState[employee.emp_id] || "",
    }));

    console.log("clicked log print for authorize", employees);
    try {
      // console.log(type);
      const res = await nodeinstance.post(url, employees, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res);
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        callBack();
        setLoading(false);
        setPopUp(false);
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  const dropDown = [
    "90 Days",
    "180 Days",
    "270 Days",
    "360 Days",
    "450 Days",
    "540 Days",
    "630 Days",
    "720 Days",
    "810 Days",
    "900 Days",
    "990 Days",
    "1080 Days",
  ];
  console.log("list.....capcture", list);
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${PopUp ? "flex" : "hidden"}`}
      >
        <div className="max-w-7xl w-full max-h-[90vh] rounded-md bg-white/95 flex flex-col p-4 relative overflow-hidden">
          {/* Header */}
          <div className="flex justify-between items-center w-full flex-shrink-0">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>

          {/* Title */}
          <div className="items-center justify-center flex-shrink-0">
            <label className="label items-center justify-center">
              <span className="label-text font-bold">{title}</span>
            </label>
          </div>

          {/* T&C checkbox */}
          <div className="flex flex-row gap-2 align-baseline px-5 py-3 flex-shrink-0">
            <input
              onClick={() => setCheck(check === false ? true : false)}
              type="checkbox"
            />
            <h4 className="">
              <span className="label-text">
                I, as the authorize representative, hereby confirm and authorize
                the following employees' tenure for the purpose of iqama renewal
              </span>
            </h4>
          </div>

          {/* Scrollable table */}
          <div className="flex-1 m-2 border border-gray-200 rounded-md overflow-hidden flex flex-col">
            {/* Sticky header — outside the scroll div so it never moves */}
            <div className="overflow-x-auto flex-shrink-0 bg-gray-100">
              <table className="min-w-full">
                <thead>
                  <tr>
                    {titles.map((columnName, index) => (
                      <th
                        key={index}
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold whitespace-nowrap"
                      >
                        {columnName}
                      </th>
                    ))}
                  </tr>
                </thead>
              </table>
            </div>

            {/* Scrollable body */}
            <div className="overflow-auto flex-1">
              <table className="min-w-full divide-y divide-gray-200">
                <tbody className="bg-white divide-y divide-gray-100">
                  {!list?.isLoading &&
                    currentList?.map((list, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-6 py-3 whitespace-nowrap text-sm">
                          {index + 1}
                        </td>
                        <td className="px-6 py-3 whitespace-nowrap text-sm">
                          {list.emp_id}
                        </td>
                        <td className="px-6 py-3 whitespace-nowrap text-sm">
                          {list.visa_provider}
                        </td>
                        <td className="px-6 py-3 whitespace-nowrap text-sm">
                          {list.sponsor_id}
                        </td>
                        <td className="px-6 py-3 whitespace-nowrap text-sm">
                          {list.client}
                        </td>
                        <td className="px-6 py-3 whitespace-nowrap text-sm">
                          {list.iqama_number}
                        </td>
                        <td className="px-6 py-3 whitespace-nowrap">
                          <select
                            className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                            onChange={(e) =>
                              handleDropChange(list.emp_id, e.target.value)
                            }
                            value={tenureState[list.emp_id] ?? list.tenure ?? ""}
                          >
                            <option value="">SELECT STATUS</option>
                            {dropDown.map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td className="px-6 py-3 whitespace-nowrap">
                          <input
                            className="input input-sm input-bordered"
                            type="text"
                            onChange={(e) =>
                              handleCommentsChange(list.emp_id, e.target.value)
                            }
                            value={commentsState[list.emp_id] ?? ""}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer / Submit */}
          <div className="items-center justify-center flex-shrink-0 border-t border-gray-100 pt-3">
            <button
              onClick={() => {
                if (check === true) {
                  update();
                } else {
                  dispatch(
                    setAppError({
                      msg: "Please select T&C",
                    })
                  );
                }
              }}
              className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-2 flex gap-3 justify-center items-center text-sm"
            >
              <p>Submit</p>
              {loading ? <CgSpinner className="animate-spin" /> : ""}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
